var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingGeneratorGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9234 11.411C29.8322 11.1426 29.6645 10.9068 29.4408 10.7326C29.2171 10.5584 28.9473 10.4536 28.6647 10.431L20.3983 9.77419L16.8211 1.85679C16.7072 1.60179 16.5219 1.3852 16.2875 1.23317C16.0532 1.08113 15.7799 1.00015 15.5006 1C15.2213 0.999847 14.9479 1.08053 14.7134 1.2323C14.4789 1.38408 14.2934 1.60046 14.1792 1.85534L10.602 9.77419L2.3355 10.431C2.05775 10.453 1.79223 10.5545 1.5707 10.7234C1.34916 10.8924 1.18099 11.1215 1.0863 11.3835C0.991618 11.6455 0.974428 11.9292 1.03679 12.2007C1.09915 12.4722 1.23842 12.72 1.43794 12.9145L7.54683 18.8688L5.38631 28.223C5.32071 28.5061 5.34174 28.8025 5.44666 29.0735C5.55159 29.3446 5.73557 29.5778 5.97473 29.743C6.21389 29.9082 6.49719 29.9977 6.78787 30C7.07854 30.0022 7.36318 29.917 7.60483 29.7554L15.5001 24.4926L23.3954 29.7554C23.6424 29.9194 23.9337 30.0038 24.2301 29.9973C24.5265 29.9908 24.8138 29.8937 25.0533 29.7191C25.2929 29.5445 25.4732 29.3007 25.5701 29.0205C25.6669 28.7403 25.6757 28.4372 25.5951 28.152L22.943 18.8732L29.5203 12.9551C29.9509 12.5665 30.109 11.9605 29.9234 11.411Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGeneratorGrey);
export default __webpack_public_path__ + "static/media/rating_generator_grey.0f6d48dd97b84d8cb5212ec4b8d4e11f.svg";
export { ForwardRef as ReactComponent };